import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './src/navigations/index';

// css
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@tremor/react/dist/esm/tremor.css';
import "swagger-ui-react/swagger-ui.css";

// redux
import { storeConfig } from './src/redux/';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';

const { store, persistor } = storeConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <React.StrictMode>
        <Router />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
